"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var analytics_1 = require("@cian/analytics");
var React = require("react");
var style_1 = require("@cian/utils/lib/shared/style");
var styles = require('./index.css');
var ChatsNotificator = /** @class */ (function (_super) {
    tslib_1.__extends(ChatsNotificator, _super);
    function ChatsNotificator() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ChatsNotificator.prototype.render = function () {
        var notificationsCount = this.props.notificationsCount;
        return (React.createElement("a", tslib_1.__assign({}, style_1.mergeStyles(styles['container'], Number(notificationsCount) === 0 && styles['container--inactive']), { href: "/dialogs/", target: "_blank", onClick: function () { return analytics_1.ca('event', {
                action: 'top_menu',
                category: 'other_page',
                label: 'messages',
                name: 'oldevent',
            }); } }),
            React.createElement("div", { className: styles['icon'] },
                React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 16 16", width: "15", height: "15" },
                    React.createElement("path", { fill: "currentColor", d: "M1.048 12.085a.434.434 0 0 0-.053-.234 7.752 7.752 0 0 1-.962-4.51c.242-2.589 1.453-4.642 3.644-6.048A8.03 8.03 0 0 1 8.037 0a8.014 8.014 0 0 1 7.917 7.145 8.002 8.002 0 0 1-6.214 8.66A8.257 8.257 0 0 1 7.975 16a8.04 8.04 0 0 1-3.801-.976.527.527 0 0 0-.237-.06h-.053c-1.054.14-2.095.284-3.14.43l-.16.01c.085-.612.164-1.193.246-1.777.072-.507.152-1.027.218-1.542zM4.8 8.8a.8.8 0 1 0 0-1.6h-.001A.8.8 0 0 0 4.8 8.8zm3.2 0a.8.8 0 1 0 0-1.6h-.001A.8.8 0 0 0 8 8.8zm3.2 0a.8.8 0 0 0 0-1.6h-.001a.8.8 0 1 0 .001 1.6z" })),
                Number(notificationsCount) > 0 && React.createElement("div", { className: styles['icon-dot'] })),
            notificationsCount !== null && React.createElement("div", { className: styles['count'] }, notificationsCount)));
    };
    return ChatsNotificator;
}(React.Component));
exports.ChatsNotificator = ChatsNotificator;



//////////////////
// WEBPACK FOOTER
// ./src/shared/chats_notificator/index.tsx
// module id = 290
// module chunks = 2